
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"15","viewBox":"0 0 17 15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14.7952 0.853403L5.24852 10.0667L2.71519 7.36007C2.24852 6.92007 1.51519 6.8934 0.981852 7.26674C0.461852 7.6534 0.315185 8.3334 0.635185 8.88007L3.63519 13.7601C3.92852 14.2134 4.43519 14.4934 5.00852 14.4934C5.55519 14.4934 6.07519 14.2134 6.36852 13.7601C6.84852 13.1334 16.0085 2.2134 16.0085 2.2134C17.2085 0.986737 15.7552 -0.093263 14.7952 0.84007V0.853403Z","fill":"currentColor"}})])
          )
        }
      }
    